import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="bg-background-100 py-16 md:py-24 px-4 md:px-8 lg:px-12">
      <div className="w-full max-w-7xl mx-auto">
        <p className="text-xs uppercase tracking-widest text-foreground-500 mb-3 font-label">
          分类导航
        </p>
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-12 md:mb-16">
          想吃什么瓜
          <br />
          点这里
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/70 hover:border-primary-200 transition-all hover:shadow-sm"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-4">
                <i
                  className={`${cat.icon} text-2xl text-foreground-700 group-hover:text-primary-500 transition-colors`}
                />
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
              <div className="mt-4 flex items-center gap-1 text-xs text-foreground-400">
                <span>{cat.articleCount}</span>
                <span>篇爆料</span>
                <i className="ri-arrow-right-line ml-auto text-foreground-400 group-hover:text-primary-500 transition-colors" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}